import FriendAvatar from "@/components/FriendAvatar";
import { useFriendsStore } from "@/features/friends/store/useFriendsStore";
import type { EditorPerson } from "../types/bills.types";

/** The person's Friend avatar, always current (not frozen on the bill). The owner has none. */
export default function PersonAvatar({
  person,
  size = 20,
}: {
  person: EditorPerson;
  size?: number;
}) {
  const friend = useFriendsStore((s) =>
    s.friends.find((f) => f.id === person.friendId),
  );
  if (person.isOwner || !person.friendId) return null;
  return (
    <FriendAvatar
      name={person.name}
      avatar={friend?.avatar ?? null}
      friendId={person.friendId}
      size={size}
    />
  );
}
